module.exports = __webpack_public_path__ + "static/media/Portrait-10184.660ba079.jpg";